<template>
    <modal-base tenant-state="answered">
        <template #title>
            Connected to Your Lawyer
        </template>

        <template #subtitle>You&rsquo;ve connected to your lawyer!</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            // this.$store.commit('card', 'contact');
        }
    }
</script>
